export default __webpack_public_path__ + "static/media/Standard04.ad601e01.png";